import { render, staticRenderFns } from "./PreguntasFrecuentesContent.vue?vue&type=template&id=11163e62&scoped=true"
import script from "./PreguntasFrecuentesContent.vue?vue&type=script&lang=js"
export * from "./PreguntasFrecuentesContent.vue?vue&type=script&lang=js"
import style0 from "./PreguntasFrecuentesContent.vue?vue&type=style&index=0&id=11163e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11163e62",
  null
  
)

export default component.exports